module.exports = __webpack_public_path__ + "c_static/img/2-4电脑天猫购物车.11a0aec.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/img/收藏购物车/2-4电脑天猫购物车.jpg
// module id = pwvg
// module chunks = 33